var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { injectable } from 'inversify';
import { BaseManagementService } from '@/services/base-management-service';
var ReferenceDataService = /** @class */ (function (_super) {
    __extends(ReferenceDataService, _super);
    function ReferenceDataService() {
        return _super.call(this, '') || this;
    }
    ReferenceDataService.prototype.getDefault = function () {
        return {
            id: 0,
            module: '',
            code: '',
            shortDescription: '',
            description: '',
            comments: '',
        };
    };
    ReferenceDataService.prototype.getValidationRules = function () {
        return {
            code: { required: true, max: 30, isDuplicateCode: true },
            shortDescription: { max: 100 },
            description: { max: 500 },
            comments: { max: 500 },
        };
    };
    ReferenceDataService.prototype.getFiltersByModule = function (module) {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, responseMessage, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        endpoint = '/api/v1/filter/getfilters';
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, { Module: module })];
                    case 1:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200) {
                            return [2 /*return*/, responseMessage];
                        }
                        else {
                            throw new Error('Unable to get default filters');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error("Unable to get default filters");
                        console.error(error_1);
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ReferenceDataService.prototype.getAllUserFilters = function (userId) {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, responseMessage, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        endpoint = '/api/v1/filter/getalluserfilters';
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, { UserId: userId })];
                    case 1:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200) {
                            return [2 /*return*/, responseMessage];
                        }
                        else {
                            throw new Error('Unable to get default filters');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        console.error("Unable to get default filters");
                        console.error(error_2);
                        throw error_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ReferenceDataService.prototype.GetInitialFilters = function (role) {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, responseMessage, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        endpoint = '/api/v1/filter/GetInitialFilters';
                        return [4 /*yield*/, _super.prototype.post.call(this, endpoint, { Role: role })];
                    case 1:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200) {
                            return [2 /*return*/, responseMessage];
                        }
                        else {
                            throw new Error('Unable to get default filters');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        console.error("Unable to get default filters");
                        console.error(error_3);
                        throw error_3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ReferenceDataService.prototype.getModules = function () {
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, responseMessage, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        endpoint = '/api/v1/reference-data/getmodules';
                        return [4 /*yield*/, _super.prototype.get.call(this, endpoint)];
                    case 1:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200) {
                            return [2 /*return*/, responseMessage];
                        }
                        else {
                            throw new Error('Unable to get modules');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_4 = _a.sent();
                        console.error("Unable to get modules");
                        console.error(error_4);
                        throw error_4;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ReferenceDataService.prototype.getModulesByRequest = function (request, url) {
        if (url === void 0) { url = '/api/v1/reference-data/getbymodules'; }
        return __awaiter(this, void 0, Promise, function () {
            var modules, endpoint, response, responseMessage, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        modules = request.modules.join('&modules=');
                        endpoint = url + "?modules=" + modules + "&includeDeleted=" + (request.includeDeleted ? 'true' : 'false');
                        return [4 /*yield*/, _super.prototype.get.call(this, endpoint)];
                    case 1:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200 && responseMessage.success) {
                            return [2 /*return*/, {
                                    success: true,
                                    data: responseMessage.data.referenceData,
                                }];
                        }
                        else {
                            throw new Error('Unable to get reference data');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_5 = _a.sent();
                        console.error("Unable to get reference data");
                        console.error(error_5);
                        throw error_5;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ReferenceDataService.prototype.getAllByRequest = function (request, url) {
        if (url === void 0) { url = '/api/v1/reference-data/getbymodule'; }
        return __awaiter(this, void 0, Promise, function () {
            var endpoint, response, responseMessage, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        endpoint = url + "?module=" + request.module + "&includeDeleted=" + (request.includeDeleted ? 'true' : 'false');
                        return [4 /*yield*/, _super.prototype.get.call(this, endpoint)];
                    case 1:
                        response = _a.sent();
                        responseMessage = response.data;
                        if (response.status === 200 && responseMessage.success) {
                            return [2 /*return*/, {
                                    success: true,
                                    data: responseMessage.data.referenceData,
                                }];
                        }
                        else {
                            throw new Error('Unable to get reference data');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_6 = _a.sent();
                        console.error("Unable to get reference data");
                        console.error(error_6);
                        throw error_6;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ReferenceDataService.prototype.get = function (url) {
        return __awaiter(this, void 0, Promise, function () {
            var response, data, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, _super.prototype.get.call(this, "/api/v1/reference-data" + url)];
                    case 1:
                        response = _a.sent();
                        if (response.status === 200) {
                            data = response.data;
                            if (data.success === true) {
                                return [2 /*return*/, data.data];
                            }
                            else {
                                throw new Error('Not successful');
                            }
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_7 = _a.sent();
                        console.warn("Unable to get reference data from " + url);
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ReferenceDataService = __decorate([
        injectable(),
        __metadata("design:paramtypes", [])
    ], ReferenceDataService);
    return ReferenceDataService;
}(BaseManagementService));
export { ReferenceDataService };
